export default __webpack_public_path__ + "static/media/File Attachment- CBH_GR107_Total_Set2020.a2f4f983.gpx";